import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { JsonEditorInput } from '../../components/json/JsonEditor'
import { HIDE_CANVAS_DIALOG, SHOW_CANVAS_DIALOG } from '../../store/actions'
import { AppDispatch, RootState } from '@/store'

const FormatPromptValuesDialog = ({ show, dialogProps, onChange, onCancel }) => {
    const portalElement = document.getElementById('portal')
    const customization = useSelector((state: RootState) => state.customization)
    const dispatch = useDispatch<AppDispatch>()

    useEffect(() => {
        if (show) {
            dispatch({ type: SHOW_CANVAS_DIALOG });
        } else {
            dispatch({ type: HIDE_CANVAS_DIALOG });
        }
        // Cleanup function that hides the dialog when the component unmounts.
        return () => {
            dispatch({ type: HIDE_CANVAS_DIALOG });
        };
    }, [show, dispatch]);
    

    const component = show ? (
        <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="fixed inset-0 bg-gray-600 opacity-50" onClick={onCancel}></div>
            <div className="bg-white rounded-lg shadow-lg max-w-4xl mx-4 relative z-10 overflow-hidden">
                <div className="p-4 border-b border-gray-300">
                    <h3 className="text-lg font-semibold" id='alert-dialog-title'>
                        Format Prompt Values
                    </h3>
                </div>
                <div className="p-4 max-h-[calc(100vh-220px)] overflow-auto">
                    <JsonEditorInput
                        onChange={(newValue) => onChange(newValue)}
                        value={dialogProps.value}
                        isDarkMode={customization.isDarkMode}
                        inputParam={dialogProps.inputParam}
                        nodes={dialogProps.nodes}
                        edges={dialogProps.edges}
                        nodeId={dialogProps.nodeId}
                    />
                </div>
                <div className="p-4 border-t border-gray-300 flex justify-end">
                    <button
                        onClick={onCancel}
                        className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-100"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    ) : null

    return portalElement ? createPortal(component, portalElement) : null
}

FormatPromptValuesDialog.propTypes = {
    show: PropTypes.bool,
    dialogProps: PropTypes.object,
    onChange: PropTypes.func,
    onCancel: PropTypes.func
}

export default FormatPromptValuesDialog
